import { useQuery, UseQueryOptions } from 'react-query';

import { getFormAgreement } from '@app/store/transport-layer/form/terms';

export default function useFormTerms(
  options: UseQueryOptions<
    {
      formUseAgreed: boolean;
    },
    Error
  >
) {
  return useQuery<{ formUseAgreed: boolean }, Error>(
    'form/useFormTerms',
    getFormAgreement,
    options
  );
}
